import { DateTime } from "luxon"
import { LogError } from "./logger"

export const DateFormat = DateTime.DATE_SHORT
export const DateTimeFormat = DateTime.DATETIME_SHORT
export const TimeFormat = DateTime.TIME_SIMPLE

const _getDateTime = (date) => {
  if (date instanceof Date) {
    if (Number.isNaN(date.getTime())) return null
    return DateTime.fromJSDate(date, { zone: "utc" })
  }
  if (typeof date === "string") {
    return DateTime.fromISO(date, { zone: "utc" })
  }
  return null
}

export const formatToLocalDate = (date) => {
  if (!date) return ""
  const dt = _getDateTime(date)
  return dt?.isValid ? dt.toLocal().toLocaleString(DateFormat) : ""
}

export const formatToLocalDateTime = (date) => {
  if (!date) return ""
  const dt = _getDateTime(date)
  return dt?.isValid ? dt.toLocal().toLocaleString(DateTimeFormat) : ""
}

export const formatToLocalTime = (date) => {
  if (!date) return ""
  const dt = _getDateTime(date)
  return dt?.isValid ? dt.toLocal().toLocaleString(TimeFormat) : ""
}

export const parseToISOString = (dateStr, format) => {
  if (!dateStr) return ""
  const dt = DateTime.fromFormat(dateStr, format)
  if (!dt.isValid) {
    LogError("Invalid date:", dt.invalidExplanation)
    return ""
  }
  return dt.toISO()
}

export const parseDatesInObj = (obj) => {
  const isDateRegex =
    /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\.[0-9]+)?(Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])?$/

  return Object.entries(obj || {}).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: isDateRegex.test(value) ? new Date(value) : value,
    }
  }, {})
}
